import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();
  
  const [userProgress, setUserProgress] = useState({
    studyPackCompleted: false,
    prepTestCompleted: false,
    mockTestCompleted: false
  });

  const handleStartLearning = () => {
    navigate('/study-pack');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleTopicClick = (topicType) => {
    switch (topicType) {
      case 'study-pack':
        handleNavigation('/study-pack');
        break;
      
      case 'prep-test':
        if (!userProgress.studyPackCompleted) {
          alert('Please complete Study Pack first before attempting Prep Test.');
          return;
        }
        handleNavigation('/prep-test');
        break;
      
      case 'mock-test':
        if (!userProgress.studyPackCompleted) {
          alert('Please complete Study Pack and Prep Test first before attempting Mock Test.');
          return;
        }
        if (!userProgress.prepTestCompleted) {
          alert('Please complete Prep Test first before attempting Mock Test.');
          return;
        }
        handleNavigation('/mock-test');
        break;
      
      default:
        break;
    }
  };

  // Function to simulate completing study pack (for demo purposes)
  const completeStudyPack = () => {
    setUserProgress(prev => ({ ...prev, studyPackCompleted: true }));
  };

  const completePrepTest = () => {
    setUserProgress(prev => ({ ...prev, prepTestCompleted: true }));
  };

  return (
    <div style={styles.container}>
      <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
      <link href="https://cdn.materialdesignicons.com/7.4.47/css/materialdesignicons.min.css" rel="stylesheet" />
      

      <div style={styles.progressCardSection}>
        <div style={styles.card}>
          <div style={styles.cardInner}>
            <div style={styles.mainContainer}>
              <div style={styles.leftSection}>
                <div style={styles.circleContainer}>
                  <div style={styles.circleWrapper}>
                    <div style={styles.circleSvgContainer}>
                      <svg width="122" height="122" viewBox="0 0 122 122" role="img" style={styles.circleSvg}>
                        <rect x="0" y="0" width="122" height="122" fill="none"></rect>
                        <g>
                          <path d="M0,-61A61,61,0,0,1,1.333,-60.985L1.093,-49.988A50,50,0,0,0,0,-50Z" shapeRendering="auto" fill="rgb(102, 187, 104)" padding="10" transform="translate(61, 61)" role="presentation"></path>
                          <path d="M1.333,-60.985L1.093,-49.988Z" shapeRendering="auto" fill="rgb(221, 165, 58)" padding="10" transform="translate(61, 61)" role="presentation"></path>
                          <path d="M1.333,-60.985A61,61,0,0,1,5.989,-60.705L4.909,-49.758A50,50,0,0,0,1.093,-49.988Z" shapeRendering="auto" fill="rgb(214, 101, 101)" padding="10" transform="translate(61, 61)" role="presentation"></path>
                          <path d="M5.989,-60.705A61,61,0,1,1,0,-61L0,-50A50,50,0,1,0,4.909,-49.758Z" shapeRendering="auto" fill="rgb(221, 221, 221)" padding="10" transform="translate(61, 61)" role="presentation"></path>
                        </g>
                        <div style={styles.circleOverlay}>
                          <svg width="122" height="122" viewBox="0 0 122 122" style={styles.overlaySvg}></svg>
                        </div>
                      </svg>
                    </div>
                  </div>
                  <div style={styles.iconContainer}>
                    <div style={styles.iconWrapper}>
                      <div>
                        <img alt="Product Icon" fetchPriority="auto" src="https://icon.memorang.com/icon/icon_exam_1.png" style={styles.iconImage} />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={styles.titleSection}>
                  <div style={styles.title}>
                    Study Pack
                  </div>
                  <div style={styles.examDate}>
                    <div style={styles.examDateInner}>
                      <div style={styles.examDateContent}>
                        <div style={styles.calendarIcon}>
                          <span className="mdi mdi-calendar"></span>
                        </div>
                        <div style={styles.examDateText}>
                          Set exam date
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.statsSection}>
                <div style={styles.statItem}>
                  <div style={styles.statIcon}>
                    <span className="fas fa-book-open"></span>
                  </div>
                  <div style={styles.statValue}>
                    22%
                  </div>
                  <div style={styles.statLabel}>
                    Study Pack
                  </div>
                </div>
                <div style={styles.statItem}>
                  <div style={styles.statIcon}>
                    <span className="fas fa-graduation-cap"></span>
                  </div>
                  <div style={styles.statValue}>
                    22%
                  </div>
                  <div style={styles.statLabel}>
                    Prep Test
                  </div>
                </div>
                <div style={styles.statItem}>
                  <div style={styles.statIcon}>
                    <span className="fas fa-file-alt"></span>
                  </div>
                  <div style={styles.statValue}>
                    22%
                  </div>
                  <div style={styles.statLabel}>
                    Mock Test
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.masteryHeader}>
        <div style={styles.masteryHeaderInner}>
          <div style={styles.masteryTextContainer}>
            <div style={styles.masteryText}>
              3 Subject Mastery • 735 items
            </div>
          </div>
          <div style={styles.premiumBadge}>
            <button style={styles.premiumButton}>
              <div style={styles.premiumContent}>
                <div style={styles.premiumIcon}>
                  <span className="mdi mdi-crown"></span>
                </div>
                <div style={styles.premiumText}>
                  Premium
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <div style={styles.topicsSection}>
        <div aria-label="Topics section, contains Study Packs" style={styles.topicsContainer}>
          
          <div 
            style={{
              ...styles.topicItem,
              ...(userProgress.studyPackCompleted ? styles.completedTopic : {})
            }} 
            onClick={() => handleTopicClick('study-pack')}
          >
            <div style={styles.topicItemInner}>
              <div style={styles.topicProgress}>
                <div style={styles.progressCircle}>
                  <svg width="40" height="40" viewBox="0 0 40 40" role="img">
                    <rect x="0" y="0" width="40" height="40" fill="none"></rect>
                    <g>
                      <path d="M0,-20A20,20,0,0,1,5.4,-19.258L4.24,-15.131A15.7,15.7,0,0,0,0,-15.7Z" shapeRendering="auto" fill="rgb(214, 101, 101)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                      <path d="M5.4,-19.258A20,20,0,1,1,0,-20L0,-15.7A15.7,15.7,0,1,0,4.24,-15.131Z" shapeRendering="auto" fill="rgb(221, 221, 221)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                    </g>
                  </svg>
                </div>
                <div style={styles.topicIconInner}>
                  <i 
                    className="fas fa-book-open" 
                    style={{
                      ...styles.topicPlayIcon,
                      ...(userProgress.studyPackCompleted ? styles.completedIcon : {})
                    }}
                  ></i>
                </div>
              </div>
              <div style={styles.topicDetails}>
                <div style={styles.topicName}>
                  Study Pack
                  {userProgress.studyPackCompleted && (
                    <span style={styles.completedBadge}>
                      <i className="fas fa-check" style={styles.checkIcon}></i> Completed
                    </span>
                  )}
                </div>
              </div>
              <div style={styles.topicItems}>
                <div style={styles.itemsBadge}>
                  735 items
                </div>
              </div>
            </div>
          </div>

          <div 
            style={{
              ...styles.topicItem,
              ...(!userProgress.studyPackCompleted ? styles.disabledTopic : {}),
              ...(userProgress.prepTestCompleted ? styles.completedTopic : {})
            }} 
            onClick={() => handleTopicClick('prep-test')}
          >
            <div style={styles.topicItemInner}>
              <div style={styles.topicProgress}>
                <div style={styles.progressCircle}>
                  <svg width="40" height="40" viewBox="0 0 40 40" role="img">
                    <rect x="0" y="0" width="40" height="40" fill="none"></rect>
                    <g>
                      <path d="M0,-20L0,-15.7Z" shapeRendering="auto" fill="rgb(214, 101, 101)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                      <path d="M0,-20A20,20,0,1,1,0,20A20,20,0,1,1,0,-20M0,-15.7A15.7,15.7,0,1,0,0,15.7A15.7,15.7,0,1,0,0,-15.7Z" shapeRendering="auto" fill="rgb(221, 221, 221)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                    </g>
                  </svg>
                </div>
                <div style={styles.topicIconInner}>
                  <i 
                    className="fas fa-graduation-cap" 
                    style={{
                      ...styles.topicPlayIcon,
                      ...(!userProgress.studyPackCompleted ? styles.disabledIcon : {}),
                      ...(userProgress.prepTestCompleted ? styles.completedIcon : {})
                    }}
                  ></i>
                </div>
                {!userProgress.studyPackCompleted && (
                  <div style={styles.lockIcon}>
                    <i className="fas fa-lock"></i>
                  </div>
                )}
              </div>
              <div style={styles.topicDetails}>
                <div style={styles.topicName}>
                  Prep Test
                  {userProgress.prepTestCompleted && (
                    <span style={styles.completedBadge}>
                      <i className="fas fa-check" style={styles.checkIcon}></i> Completed
                    </span>
                  )}
                  {!userProgress.studyPackCompleted && (
                    <span style={styles.lockedText}>
                      <i className="fas fa-lock" style={styles.lockTextIcon}></i> Complete Study Pack first
                    </span>
                  )}
                </div>
              </div>
              <div style={styles.topicItems}>
                <div style={styles.itemsBadge}>
                  12 tests
                </div>
              </div>
            </div>
          </div>

          <div 
            style={{
              ...styles.topicItem,
              ...((!userProgress.studyPackCompleted || !userProgress.prepTestCompleted) ? styles.disabledTopic : {}),
              ...(userProgress.mockTestCompleted ? styles.completedTopic : {})
            }} 
            onClick={() => handleTopicClick('mock-test')}
          >
            <div style={styles.topicItemInner}>
              <div style={styles.topicProgress}>
                <div style={styles.progressCircle}>
                  <svg width="40" height="40" viewBox="0 0 40 40" role="img">
                    <rect x="0" y="0" width="40" height="40" fill="none"></rect>
                    <g>
                      <path d="M0,-20L0,-15.7Z" shapeRendering="auto" fill="rgb(214, 101, 101)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                      <path d="M0,-20A20,20,0,1,1,0,20A20,20,0,1,1,0,-20M0,-15.7A15.7,15.7,0,1,0,0,15.7A15.7,15.7,0,1,0,0,-15.7Z" shapeRendering="auto" fill="rgb(221, 221, 221)" padding="10" transform="translate(20, 20)" role="presentation"></path>
                    </g>
                  </svg>
                </div>
                <div style={styles.topicIconInner}>
                  <i 
                    className="fas fa-file-alt" 
                    style={{
                      ...styles.topicPlayIcon,
                      ...((!userProgress.studyPackCompleted || !userProgress.prepTestCompleted) ? styles.disabledIcon : {}),
                      ...(userProgress.mockTestCompleted ? styles.completedIcon : {})
                    }}
                  ></i>
                </div>
                {(!userProgress.studyPackCompleted || !userProgress.prepTestCompleted) && (
                  <div style={styles.lockIcon}>
                    <i className="fas fa-lock"></i>
                  </div>
                )}
              </div>
              <div style={styles.topicDetails}>
                <div style={styles.topicName}>
                  Mock Test
                  {userProgress.mockTestCompleted && (
                    <span style={styles.completedBadge}>
                      <i className="fas fa-check" style={styles.checkIcon}></i> Completed
                    </span>
                  )}
                  {!userProgress.studyPackCompleted && (
                    <span style={styles.lockedText}>
                      <i className="fas fa-lock" style={styles.lockTextIcon}></i> Complete Study Pack first
                    </span>
                  )}
                  {userProgress.studyPackCompleted && !userProgress.prepTestCompleted && (
                    <span style={styles.lockedText}>
                      <i className="fas fa-lock" style={styles.lockTextIcon}></i> Complete Prep Test first
                    </span>
                  )}
                </div>
              </div>
              <div style={styles.topicItems}>
                <div style={styles.itemsBadge}>
                  6 exams
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div style={styles.heroSection}>
        <div style={styles.heroContent}>
          <div style={styles.heroText}>
            <h1 style={styles.heroTitle}>
              Welcome to Smart Learning Management System
            </h1>
            <p style={styles.heroSubtitle}>
              Your journey to mastering various subjects starts here. 
              Access comprehensive study materials, practice tests, and 
              track your progress all in one place.
            </p>
            
            <div style={styles.featuresGrid}>
              <div style={styles.featureItem}>
                <i className="fas fa-book-open" style={styles.featureIcon}></i>
                <div style={styles.featureText}>
                  <h3 style={styles.featureTextH3}>Study Materials</h3>
                  <p style={styles.featureTextP}>Comprehensive resources and practice questions</p>
                </div>
              </div>
              
              <div style={styles.featureItem}>
                <i className="fas fa-chart-line" style={styles.featureIcon}></i>
                <div style={styles.featureText}>
                  <h3 style={styles.featureTextH3}>Progress Tracking</h3>
                  <p style={styles.featureTextP}>Monitor your learning journey and improvements</p>
                </div>
              </div>
              
              <div style={styles.featureItem}>
                <i className="fas fa-file-alt" style={styles.featureIcon}></i>
                <div style={styles.featureText}>
                  <h3 style={styles.featureTextH3}>Mock Tests</h3>
                  <p style={styles.featureTextP}>Simulate real exam conditions</p>
                </div>
              </div>
              
              <div style={styles.featureItem}>
                <i className="fas fa-graduation-cap" style={styles.featureIcon}></i>
                <div style={styles.featureText}>
                  <h3 style={styles.featureTextH3}>Exam Prep</h3>
                  <p style={styles.featureTextP}>Premium materials for exam success</p>
                </div>
              </div>
            </div>

            <button 
              style={styles.startButton}
              onClick={handleStartLearning}
              className="start-button"
            >
              <i className="fas fa-play" style={styles.buttonIcon}></i>
              Start Learning
            </button>
          </div>
          
          <div style={styles.heroImage}>
            <div style={styles.imagePlaceholder}>
              <i className="fas fa-graduation-cap" style={styles.heroImageIcon}></i>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div style={styles.statsSections}>
        <div style={styles.statsContainers}>
          <div style={styles.statItemLarges}>
            <div style={styles.statNumberLarges}>500+</div>
            <div style={styles.statLabelLarges}>Practice Questions</div>
          </div>
          <div style={styles.statItemLarges}>
            <div style={styles.statNumberLarges}>100+</div>
            <div style={styles.statLabelLarges}>Study Topics</div>
          </div>
          <div style={styles.statItemLarges}>
            <div style={styles.statNumberLarges}>95%</div>
            <div style={styles.statLabelLarges}>Success Rate</div>
          </div>
          <div style={styles.statItemLarges}>
            <div style={styles.statNumberLarges}>24/7</div>
            <div style={styles.statLabelLarges}>Access</div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div style={styles.howItWorks}>
        <div style={styles.sectionHeader}>
          <h2 style={styles.sectionTitle}>How It Works</h2>
          <p style={styles.sectionSubtitle}>Get started in three simple steps</p>
        </div>
        
        <div style={styles.stepsContainer}>
          <div style={styles.step}>
            <div style={styles.stepNumber}>1</div>
            <div style={styles.stepContent}>
              <h3 style={styles.stepContentH3}>Study & Practice</h3>
              <p style={styles.stepContentP}>Access comprehensive study materials and practice questions across all topics.</p>
            </div>
          </div>
          
          <div style={styles.step}>
            <div style={styles.stepNumber}>2</div>
            <div style={styles.stepContent}>
              <h3 style={styles.stepContentH3}>Track Progress</h3>
              <p style={styles.stepContentP}>Monitor your performance with detailed analytics and progress tracking.</p>
            </div>
          </div>
          
          <div style={styles.step}>
            <div style={styles.stepNumber}>3</div>
            <div style={styles.stepContent}>
              <h3 style={styles.stepContentH3}>Ace Your Exam</h3>
              <p style={styles.stepContentP}>Take mock tests and get exam-ready with our premium preparation materials.</p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .start-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(44, 90, 160, 0.3);
        }

        .feature-item:hover {
          transform: translateY(-5px);
        }

        .topic-item:hover {
          background-color: rgba(0, 0, 0, 0.02);
          cursor: pointer;
        }
        
        .disabled-topic:hover {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    fontFamily: '"Open Sans", sans-serif',
  },
  
  disabledTopic: {
    opacity: 0.6,
    cursor: 'not-allowed !important',
    backgroundColor: '#f8f9fa',
  },
  completedTopic: {
    backgroundColor: '#f0f9ff',
    borderLeft: '4px solid #28a745',
  },
  disabledIcon: {
    color: '#6c757d !important',
  },
  completedIcon: {
    color: '#28a745 !important',
  },
  lockIcon: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    backgroundColor: '#dc3545',
    color: 'white',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
  },
  completedBadge: {
    color: '#28a745',
    fontSize: '12px',
    fontWeight: '600',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  checkIcon: {
    fontSize: '10px',
  },
  lockedText: {
    color: '#dc3545',
    fontSize: '12px',
    fontWeight: '500',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  lockTextIcon: {
    fontSize: '10px',
  },

  
  masteryHeader: {
    padding: '20px 20px 0px 20px',
    backgroundColor: '#f8f9fa',
  },
  masteryHeaderInner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingRight: '0px',
  },
  masteryTextContainer: {
    padding: '18px 0px',
    gap: '16px',
    display: 'flex',
  },
  masteryText: {
    direction: 'ltr',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.1px',
    fontWeight: '500',
    lineHeight: '20px',
    fontSize: '14px',
    color: 'rgb(25, 28, 29)',
  },
  premiumBadge: {
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: '8px',
    backgroundColor: 'rgb(255, 215, 0)',
    boxShadow: 'rgba(0, 0, 0, 0) 0px 0px 0px',
  },
  premiumButton: {
    border: 'none',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  premiumContent: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '0px',
  },
  premiumIcon: {
    fontSize: '18px',
    fontFamily: 'material-community',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: 'rgb(26, 33, 43)',
  },
  premiumText: {
    direction: 'ltr',
    color: 'rgb(0, 0, 0)',
    marginRight: '12px',
    marginLeft: '6px',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.5px',
    fontWeight: '500',
    lineHeight: '16px',
    fontSize: '11px',
  },

  progressCardSection: {
    padding: '20px',
    backgroundColor: '#f8f9fa',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
  },
  cardInner: {
    padding: '24px',
  },
  mainContainer: {
    width: '100%',
    flexDirection: 'row',
    gap: '16px',
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
  },
  leftSection: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: '16px',
    display: 'flex',
  },
  circleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    position: 'relative',
  },
  circleWrapper: {
    position: 'relative',
  },
  circleSvgContainer: {
    alignSelf: 'center',
    position: 'relative',
  },
  circleSvg: {
    width: '122px',
    height: '122px',
  },
  circleOverlay: {
    zIndex: 99,
    position: 'absolute',
    top: '0px',
    left: '0px',
  },
  overlaySvg: {
    overflow: 'visible',
    width: '100%',
    height: '100%',
  },
  iconContainer: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  iconWrapper: {
    overflow: 'hidden',
    width: '64px',
    height: '64px',
    borderRadius: '14.08px',
    borderWidth: '0px',
    borderColor: 'rgb(0, 31, 40)',
    position: 'relative',
  },
  iconImage: {
    objectPosition: 'left 50% top 50%',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0px',
    top: '0px',
    objectFit: 'contain',
  },
  titleSection: {
    alignItems: 'flex-start',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    WebkitLineClamp: 2,
    direction: 'ltr',
    color: 'rgb(25, 28, 29)',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.15px',
    fontWeight: '600',
    lineHeight: '24px',
    fontSize: '16px',
    maxWidth: '300px',
    margin: 0,
  },
  examDate: {
    cursor: 'pointer',
  },
  examDateInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    display: 'flex',
  },
  examDateContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    display: 'flex',
  },
  calendarIcon: {
    fontSize: '16px',
    color: 'rgb(16, 61, 75)',
    fontFamily: 'material-community',
    fontWeight: 'normal',
    fontStyle: 'normal',
  },
  examDateText: {
    letterSpacing: '0px',
    fontWeight: '400',
    direction: 'ltr',
    fontFamily: '"Open Sans", sans-serif',
    color: 'rgb(16, 61, 75)',
    fontSize: '14px',
  },
  statsSection: {
    flexDirection: 'row',
    gap: '24px',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexGrow: 1,
    maxWidth: '350px',
    display: 'flex',
  },
  statItem: {
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'column',
    gap: '4px',
    borderWidth: '0px',
    borderColor: 'rgb(191, 200, 204)',
    padding: '0px',
    cursor: 'pointer',
    textAlign: 'center',
  },
  statIcon: {
    fontSize: '24px',
    color: 'rgb(128, 0, 128)',
    fontFamily: 'material-community',
    fontWeight: 'normal',
    fontStyle: 'normal',
    marginBottom: '4px',
  },
  statValue: {
    direction: 'ltr',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.25px',
    fontWeight: '400',
    lineHeight: '20px',
    fontSize: '14px',
    textAlign: 'center',
    color: 'rgb(64, 72, 76)',
  },
  statLabel: {
    direction: 'ltr',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.5px',
    fontWeight: '500',
    lineHeight: '16px',
    fontSize: '11px',
    color: 'rgb(64, 72, 76)',
    textAlign: 'center',
    textTransform: 'uppercase',
  },

  topicsSection: {
    padding: '20px',
    backgroundColor: '#f8f9fa',
  },
  topicsContainer: {
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 3px',
    backgroundColor: 'rgb(238, 245, 248)',
  },
  topicItem: {
    cursor: 'pointer',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
  },
  topicItemInner: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    gap: '16px',
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  topicProgress: {
    position: 'relative',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progressCircle: {
    width: '40px',
    height: '40px',
  },
  topicIconInner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  topicPlayIcon: {
    fontSize: '16px',
    color: 'rgb(64, 72, 76)',
  },
  topicDetails: {
    flex: 1,
  },
  topicName: {
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    direction: 'ltr',
    color: 'rgb(25, 28, 29)',
    fontSize: '16px',
    lineHeight: '1.4',
  },
  topicItems: {
    marginLeft: '16px',
  },
  itemsBadge: {
    backgroundColor: 'rgb(242, 233, 216)',
    color: 'rgb(25, 28, 29)',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: '500',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
  },

  heroSection: {
    backgroundColor: '#ffffff',
    padding: '60px 20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
  },
  heroContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    gap: '60px',
  },
  heroText: {
    flex: 1,
  },
  heroTitle: {
    fontSize: '48px',
    fontWeight: '700',
    margin: '0 0 20px 0',
    lineHeight: '1.2',
    fontFamily: '"Open Sans", sans-serif',
  },
  heroSubtitle: {
    fontSize: '20px',
    margin: '0 0 40px 0',
    opacity: '0.9',
    lineHeight: '1.6',
    fontFamily: '"Open Sans", sans-serif',
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '30px',
    marginBottom: '40px',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    transition: 'transform 0.3s ease',
  },
  featureIcon: {
    fontSize: '24px',
    color: '#ffd700',
    marginTop: '5px',
    flexShrink: 0,
  },
  featureText: {
    flex: 1,
  },
  featureTextH3: {
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    fontFamily: '"Open Sans", sans-serif',
  },
  featureTextP: {
    fontSize: '14px',
    margin: '0',
    opacity: '0.8',
    lineHeight: '1.5',
    fontFamily: '"Open Sans", sans-serif',
  },
  startButton: {
    backgroundColor: '#ffd700',
    border: 'none',
    borderRadius: '50px',
    padding: '18px 40px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#2c5aa0',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontFamily: '"Open Sans", sans-serif',
    boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)',
  },
  buttonIcon: {
    fontSize: '20px',
  },
  heroImage: {
    flex: '0 0 400px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagePlaceholder: {
    width: '300px',
    height: '300px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(10px)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
  },
  heroImageIcon: {
    fontSize: '120px',
    color: 'rgba(255, 255, 255, 0.3)',
  },

  statsSections: {
    backgroundColor: '#ffffff',
    padding: '60px 20px',
  },
  statsContainers: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '40px',
    textAlign: 'center',
  },
  statItemLarges: {
    padding: '20px',
  },
  statNumberLarges: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#2c5aa0',
    marginBottom: '10px',
    fontFamily: '"Open Sans", sans-serif',
  },
  statLabelLarges: {
    fontSize: '16px',
    color: '#666666',
    fontWeight: '500',
    fontFamily: '"Open Sans", sans-serif',
  },

  howItWorks: {
    backgroundColor: '#f8f9fa',
    padding: '80px 20px',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '60px',
  },
  sectionTitle: {
    fontSize: '36px',
    fontWeight: '700',
    color: '#2c5aa0',
    margin: '0 0 15px 0',
    fontFamily: '"Open Sans", sans-serif',
  },
  sectionSubtitle: {
    fontSize: '18px',
    color: '#666666',
    margin: '0',
    fontFamily: '"Open Sans", sans-serif',
  },
  stepsContainer: {
    maxWidth: '1000px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '40px',
  },
  step: {
    backgroundColor: '#ffffff',
    padding: '40px 30px',
    borderRadius: '15px',
    textAlign: 'center',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e0e0e0',
    transition: 'transform 0.3s ease',
  },
  stepNumber: {
    width: '60px',
    height: '60px',
    backgroundColor: '#2c5aa0',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: '700',
    margin: '0 auto 20px auto',
    fontFamily: '"Open Sans", sans-serif',
  },
  stepContent: {
    textAlign: 'center',
  },
  stepContentH3: {
    fontSize: '22px',
    fontWeight: '600',
    color: '#333333',
    margin: '0 0 15px 0',
    fontFamily: '"Open Sans", sans-serif',
  },
  stepContentP: {
    fontSize: '16px',
    color: '#666666',
    lineHeight: '1.6',
    margin: '0',
    fontFamily: '"Open Sans", sans-serif',
  },
};

export default LandingPage;